export const OVERLAY_CLASSES = {
  hidden: 'opacity-none',
  visible: 'opacity-full',
};

export const PANEL_CLASSES = {
  visible: 'translate-x-0',
};

export const DEFAULT_PANEL_WIDTH = '400px';
